export default __webpack_public_path__ + "static/char-v-46-zh-Hant-fab7c0933117a9fd5c314fee1618ee42.mp4";